(function () {
  const ROOT_SELECTOR = '[data-product-card-video-root]';
  const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function canPlayHoverVideo() {
    return window.matchMedia(FINE_POINTER_QUERY).matches && !window.matchMedia(REDUCED_MOTION_QUERY).matches;
  }

  function loadHostedVideo(video) {
    if (video.dataset.loaded === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
    });
    video.dataset.loaded = 'true';
    video.load();
  }

  function playCardVideo(root) {
    if (!canPlayHoverVideo()) return;

    const hostedVideo = root.querySelector('[data-product-card-video]');
    const externalVideo = root.querySelector('[data-product-card-external-video]');

    if (hostedVideo) {
      loadHostedVideo(hostedVideo);
      hostedVideo.muted = true;

      const playPromise = hostedVideo.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise
          .then(() => root.classList.add('is-product-card-video-playing'))
          .catch(() => root.classList.remove('is-product-card-video-playing'));
      } else {
        root.classList.add('is-product-card-video-playing');
      }
      return;
    }

    if (externalVideo && externalVideo.dataset.src) {
      if (externalVideo.src !== externalVideo.dataset.src) {
        externalVideo.src = externalVideo.dataset.src;
      }
      externalVideo.addEventListener(
        'load',
        () => root.classList.add('is-product-card-video-playing'),
        { once: true }
      );
    }
  }

  function stopCardVideo(root) {
    root.classList.remove('is-product-card-video-playing');

    const hostedVideo = root.querySelector('[data-product-card-video]');
    const externalVideo = root.querySelector('[data-product-card-external-video]');

    if (hostedVideo) {
      hostedVideo.pause();
      try {
        hostedVideo.currentTime = 0;
      } catch (error) {
        // Some browsers do not allow seeking until video metadata is available.
      }
    }

    if (externalVideo && externalVideo.src) {
      externalVideo.src = 'about:blank';
    }
  }

  document.addEventListener('pointerover', (event) => {
    const root = event.target.closest?.(ROOT_SELECTOR);
    if (!root || root.contains(event.relatedTarget)) return;
    playCardVideo(root);
  });

  document.addEventListener('pointerout', (event) => {
    const root = event.target.closest?.(ROOT_SELECTOR);
    if (!root || root.contains(event.relatedTarget)) return;
    stopCardVideo(root);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll(`${ROOT_SELECTOR}.is-product-card-video-playing`).forEach(stopCardVideo);
  });
})();
